var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary mr-1",on:{"click":_vm.generateCsv}},[_vm._v("\n    "+_vm._s(_vm.$t('awesomeTable.exportCSV'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }